

const backDashBoard = [
  // '/PLUGIN/INSTANCEMANAGEMENTLIST'
];
export default backDashBoard;
